<template>
  <h2>
    <slot></slot>
  </h2>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "Header2",
})
</script>

<style scoped>
h2 {
  font-size: 24px;
  font-weight: 700;
}
</style>
